import { RadioGroup, Radio, Stack } from '@mui/material'
import { RepairShopSearchResultDto } from '@src/model/repairShopDom'
import React from 'react'
import RepairShopItem from './RepairShopItem'

interface RepairShopListProps {
  repairShops: RepairShopSearchResultDto[]
  selectedMatch: number | null
  radioGroupAriaLabelledby: string
  onSelect: (matchId: number) => void
}

interface RepairShopSelectionItemProps {
  repairShop: RepairShopSearchResultDto
}

const RepairShopSelectionItem = ({
  repairShop,
}: RepairShopSelectionItemProps) => {
  return (
    <Stack
      sx={(theme) => ({
        mb: 2,
        backgroundColor: theme.palette.common.white,
      })}
      direction={'row'}
      component={'label'}
    >
      <Radio
        value={repairShop.matchId}
        inputProps={{
          'aria-labelledby': `match-${repairShop.matchId}`,
        }}
        sx={{
          '&.Mui-focusVisible': {
            outline: '5px solid #192d6a',
          },
        }}
        data-testid={`selection-page.select-repair-shop-${repairShop.matchId}`}
      />
      <RepairShopItem
        repairShop={repairShop}
        id={`match-${repairShop.matchId}`}
      />
    </Stack>
  )
}

const RepairShopList = ({
  repairShops,
  selectedMatch,
  onSelect,
  radioGroupAriaLabelledby,
}: RepairShopListProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const matchId = (event.target as HTMLInputElement).value
    onSelect(Number(matchId))
  }

  return (
    <Stack
      sx={{
        margin: 'auto',
        maxWidth: 'lg',
      }}
    >
      <RadioGroup
        value={selectedMatch}
        onChange={handleChange}
        aria-labelledby={radioGroupAriaLabelledby}
      >
        {repairShops.map((item: RepairShopSearchResultDto) => (
          <RepairShopSelectionItem key={item.id} repairShop={item} />
        ))}
      </RadioGroup>
    </Stack>
  )
}

export default RepairShopList
